/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

const retornaCss = (props) => {
  let retorno = 'dtp-datagrid-header';
  if (props && props.cssLinha) {
    retorno = props.cssLinha;
  }
  return retorno;
};

const textoDestaque = texto => (
  (
    <React.Fragment>
      <span style={{
          position: 'relative',
          padding: '5px 5px 5px 5px',
          color: '#ffffff',
          fontweight: '600',
          backgroundColor: '#03a9f4',
          borderRadius: '7px',
          width: '100%',
          fontSize: '1.4rem',
          margin: 'auto',
          height: '10px',
          paddingTop: '2px',
          top: '-1.2rem',
        }}
      >
        {texto}
      </span>
    </React.Fragment>
  )
);

const textoDestaqueApagarValores = texto => (
  (
    <React.Fragment>
      <span style={{
          position: 'relative',
          padding: '5px 5px 5px 5px',
          color: '#ffffff',
          fontweight: '600',
          backgroundColor: 'darkred',
          borderRadius: '7px',
          width: '100%',
          fontSize: '1.4rem',
          margin: 'auto',
          height: '10px',
          paddingTop: '2px',
          top: '-1.2rem',
        }}
      >
        {texto}
      </span>
    </React.Fragment>
  )
);

const textoDestaqueAno = texto => (
  (
    <React.Fragment>
      <span style={{
          position: 'relative',
          fontweight: '800',
          width: '100%',
          fontSize: '4.0rem',
          margin: 'auto',
          height: '10px',
          top: '-0.1rem',
          paddingRight: '10px',
        }}
      >
        {texto}
      </span>
    </React.Fragment>
  )
);

const criarLink = (props) => {
  if (props && props.criarLink) {
    const exibirLink = props.verificarHabilitacaoBotaoLimpeza(props.title, props.remuneracoesPreenchidas);
    return (
      <React.Fragment>
        <span>
          <a href="#" onClick={() => props.alertarPreenchimentoAutomatico(props.title)}>{textoDestaque('Preencher valores automaticamente')}</a>
        </span>
        <span>&nbsp;</span>
        <span>
          <a href="#" onClick={() => props.alertarLimpezaAutomatica(props.title)}>
            {exibirLink ? textoDestaqueApagarValores('Limpar valores automaticamente') : ''}
          </a>
        </span>
      </React.Fragment>
    );
  }
  return '';
};

const DataGridCustomLink = props => (
  <section className="dtp-datagrid">
    {!props.retirarLinhaSeparadora ?
      <h3 className={props.retirarLinhaSeparadora ? 'header-sem-linha' : retornaCss(props)}>{textoDestaqueAno(props.title)}
        {!(['detalhar-ctc', 'detalhar-ctc-invalida'].includes(props.acao)) ? criarLink(props) : '' }
      </h3>
    : ''}
    <div className="dtp-datagrid-data">
      <div className="dtp-datagrid-items-box" >
        {props.children}
      </div>
    </div>
  </section>
);

DataGridCustomLink.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.element,
  retirarLinhaSeparadora: PropTypes.bool,
  cssLinha: PropTypes.string,
  criarLink: PropTypes.bool,
  alertarPreenchimentoAutomatico: PropTypes.func,
  alertarLimpezaAutomatica: PropTypes.func.isRequired,
  verificarHabilitacaoBotaoLimpeza: PropTypes.func.isRequired,
  remuneracoesPreenchidas: PropTypes.func.isRequired,
  acao: PropTypes.string,
}.isRequired;

export default DataGridCustomLink;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/DataGridCustomLink.jsx